import { useTranslation } from 'react-i18next';
import { StatusBadge } from 'src/common/components/StatusBadge/StatusBadge';

export const ESimProfileStatusBadge = ({ value }: { value: boolean }) => {
  const { t } = useTranslation();
  return value ? (
    <StatusBadge
      status="success"
      type="filled"
      label={t('products.eSim.inventory.cells.eSimProfile.enabled')}
      hideIcon
    />
  ) : (
    <StatusBadge
      status="inactive"
      type="filled"
      label={t('products.eSim.inventory.cells.eSimProfile.disabled')}
      hideIcon
    />
  );
};
